import { render, staticRenderFns } from "./spare-parts-card.vue?vue&type=template&id=0e3c8582&scoped=true"
import script from "./spare-parts-card.vue?vue&type=script&lang=js"
export * from "./spare-parts-card.vue?vue&type=script&lang=js"
import style0 from "./spare-parts-card.vue?vue&type=style&index=0&id=0e3c8582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c8582",
  null
  
)

export default component.exports